<div class="rx-banner-container" [class]="type">
    <div class="banner-message">{{message}}</div>
</div>
